import { render, staticRenderFns } from "./Quotas.vue?vue&type=template&id=58309bc2&scoped=true"
import script from "./Quotas.vue?vue&type=script&lang=js"
export * from "./Quotas.vue?vue&type=script&lang=js"
import style0 from "./Quotas.vue?vue&type=style&index=0&id=58309bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58309bc2",
  null
  
)

export default component.exports